import { Injectable } from '@angular/core';

export type ShareResult = 'success' | 'cancelled' | 'not-supported' | 'error';

export interface ShareOptions {
  title?: string;
  text?: string;
  url?: string;
}

export interface ShareFilesOptions {
  files: File[];
  title?: string;
  text?: string;
}

@Injectable({ providedIn: 'root' })
export class WebShareService {
  canShare(): boolean {
    return typeof navigator !== 'undefined' && !!navigator.share && !this.isWindows();
  }

  canShareFiles(mimeType = 'audio/mpeg'): boolean {
    if (!this.canShare() || !navigator.canShare) return false;
    const testFile = new File([''], 'test', { type: mimeType });
    return navigator.canShare({ files: [testFile] });
  }

  async share(options: ShareOptions): Promise<ShareResult> {
    if (!this.canShare()) return 'not-supported';
    return this.executeShare(options);
  }

  async shareFiles(options: ShareFilesOptions): Promise<ShareResult> {
    if (!this.canShareFiles()) return 'not-supported';
    return this.executeShare({ files: options.files, title: options.title, text: options.text });
  }

  private async executeShare(data: ShareData): Promise<ShareResult> {
    try {
      await navigator.share(data);
      return 'success';
    } catch (error) {
      return (error as Error).name === 'AbortError' ? 'cancelled' : 'error';
    }
  }

  private isWindows(): boolean {
    return typeof navigator !== 'undefined' && /Windows/i.test(navigator.userAgent);
  }
}
